import { Platform, PlatformUtil } from './platform.model';

export enum StatType {
  LOG = 'log',
  SESSION = 'session'
}

// Server apps report an arbitrary set of udids, so they count by session (a request)
// instead of device on every dashboard/loglytics stat. The Console picks the unit from
// the app platform and sends it to the server as statUnit.
export enum StatUnit {
  DEVICE = 'device',
  SESSION = 'session',
}

export function statUnit(platform?: Platform): StatUnit {
  return PlatformUtil.isServer(platform) ? StatUnit.SESSION : StatUnit.DEVICE;
}

export function statUnitLabel(platform?: Platform): 'Devices' | 'Requests' {
  return PlatformUtil.isServer(platform) ? 'Requests' : 'Devices';
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export class StatTypeUtil {
  static values() {
    return Object.values(StatType);
  }
}  
export interface StatNumber {
  exception: number; 
  error: number; 
  warning: number;
}

export interface StatDeviceNumber extends StatNumber {
  device: number;
}

export interface StatDeviceSum {
  time: Date; 
  [name: string]: Date | number;
}

export interface StatDateNumbers {
  time: Date;
  exception: number;
  error: number;
  warning: number;
  info: number;
  debug: number;
  verbose: number;
}

// Rates are fractions 0..1; unique-based (user/device) rates may be undefined for
// ranges partially beyond retention (multi-day uniques can't be summed), and user
// rates stay undefined for apps that never call registerUser (users = userId,
// devices = udid).
export interface HealthRates {
  crashFreeSessions?: number;
  errorFreeSessions?: number;
  warningFreeSessions?: number;
  crashFreeUsers?: number;
  errorFreeUsers?: number;
  warningFreeUsers?: number;
  crashFreeDevices?: number;
  errorFreeDevices?: number;
  warningFreeDevices?: number;
}

export interface DailyStatsOverall extends HealthRates {
  sessions: number;
  users?: number;
  devices?: number;
}

export interface DailyStatsHistogramEntry extends HealthRates {
  date: Date;
  sessions: number;
  users: number;
  devices: number;
}

export interface DailyStatsVersion extends HealthRates {
  version: string;
  sessions: number;
}

export interface DailyStats {
  overall: DailyStatsOverall;
  histogram: DailyStatsHistogramEntry[];
  perVersion: DailyStatsVersion[];
}
